import React, { Component } from 'react';
import LoginForm from './login/LoginForm';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../state/fetch-dux';
import Layout from '../ui/Layout';
import MetaTags from 'react-meta-tags';
import CookieLink, { handleCookieNav } from '../ui/CookieLink';
import MetaLoader from '../ui/MetaLoader';
import queryString from 'query-string';
import Loading from '../ui/Loading';
import { Redirect } from 'react-router-dom';

const REACT_APP_CHECKOUT_LINK = `${process.env.REACT_APP_CHECKOUT_LINK}`;

const clubJoinMessage = ({clubTypeId, ClubTypeId, ClubName, toJoinClubName, IsDisabled:deletedProfile}) =>{
  if(deletedProfile){
    return (
      `Our records indicate you were previously a member of Twomey. If you wish to re-join, please contact us at (707) 942-7111.`
    );
  }

  if(clubTypeId === ClubTypeId){
    return(`Our records show that you are already part of ${ClubName} membership.`);
  }

  return(`Our records show that you already have the ${ClubName} membership. Do you wish to switch to the ${toJoinClubName} membership?`);
};

class ShopLoginRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToShop: false
    }
  }
  componentDidMount() {
    const { location: { search }, getClubById } = this.props;
    const searchQuery = queryString.parse(search);
    const { clubType } = searchQuery;
    if (clubType) {
      this.setState({ clubType });
      getClubById({ clubTypeId: clubType });
    }
    window.scrollTo(0, 0);
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-login',
      'page-template-page-templatesshop-login-php',
      'page',
      'page-id-240',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-login',
      'page-template-page-templatesshop-login-php',
      'page',
      'page-id-240',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }

  componentDidUpdate() {
    const { validateLoginResult, inProgress, result: clubCartResult, error: clubCartError } = this.props;
    if (validateLoginResult &&
      !inProgress &&
      !clubCartResult && !clubCartError) {
      this.postCreateClubMembershipCart();
    }
  }

  //The club membership cart will only be created when we have the clubType param in the 
  //search query and the user does not have a prior membership.
  postCreateClubMembershipCart = () => {
    const { clubType } = this.state;
    const { createClubMembershipCart, validateLoginResult } = this.props;
    const { ClubMember } = validateLoginResult || {};
    if (clubType) {
      if (!ClubMember) {
        createClubMembershipCart({ clubType }, null, null, (result) => {
          const { success } = result;
          if (success) {
            handleCookieNav(`${REACT_APP_CHECKOUT_LINK}/shipping`, 'clubJoin=true');
          }
        });
      }
    } else {
      handleCookieNav(`${REACT_APP_CHECKOUT_LINK}/shipping/`);
    }
  }

  render() {
    const {
      postLogin,
      history,
      getCart,
      validateLogin,
      loginError,
      error,
      inProgress,
      validateLoginInProgress,
      validateLoginResult,
      clubTypeResult,
      switchClubMembership,
      switchError,
      switchInProgress
    } = this.props;

    const { redirectToShop, redirectToClubInformation } = this.state;

    if (redirectToShop)
      return <Redirect to={'/shop'} />

    if (redirectToClubInformation)
      return <Redirect to={'/account/club-information'} />

    const { clubType } = this.state;
    const clubTypeId = parseInt(clubType);
    const { ClubMember } = validateLoginResult || {};
    const { ClubTypeId, ClubName, IsDisabled } = ClubMember || {};
    const { ClubName: toJoinClubName } = clubTypeResult || {};

    const scrollToTop = () => window.scrollTo(0, 0);
    const handlePostLogin = values =>
      postLogin(values, 'login-form', null, () => {
        getCart();
        validateLogin();
      });

    return (
      <Layout>
        <MetaLoader title="Login | Twomey" />
        <MetaTags>
          <title>Login | Twomey</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta property="og:title" content="Login | Twomey" />
          <meta property="og:type" content="article" />
          <meta property="og:url" content="https://twomey.com/shop/login" />
        </MetaTags>
        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            {
              (validateLoginInProgress || inProgress) &&
              <main
                id="main"
                className="site-main shop-page nohero extra cart-page"
              >
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  marginTop: '-8rem'
                }}>
                  <Loading fullPage />
                  {clubType && <h2 style={{ marginTop: '-4rem' }}>Creating Club Membership Cart</h2>}

                </div>
              </main>
            }
            {
              !validateLoginInProgress &&
              !inProgress &&
              <>
                <main
                  id="main"
                  className="site-main shop-page nohero extra cart-page"
                >
                  {!validateLoginResult && (
                    <div className="container">
                      <div className="row justify-content-center">
                        <div className="col-md-10">
                          <div className="row">
                            <div className="col-md-6 divider-md">
                              <div className="login-box-left">
                                <h1 className="smaller">Login</h1>
                                <LoginForm
                                  onSubmit={handlePostLogin}
                                  loginError={loginError}
                                  cartError={error}
                                  inProgress={inProgress}
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                              <div className="login-box-right">
                                {
                                  clubType ?
                                    <h3>Create Account</h3>
                                    :
                                    <h3>New to Twomey</h3>
                                }

                                {
                                  clubType ?
                                    <p>
                                      New to Twomey? Let's get your payment and delivery information and create an account.
                                    </p>
                                    :
                                    <p>
                                      Let's get your payment & delivery information. You don’t need an account to checkout, but you’ll have the option to create one if you like.
                                    </p>
                                }

                                {/* <p>
                            We respect your privacy and will not share any of your personal information.
                          </p> */}
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                  <CookieLink
                                    href='#'
                                    className="btn btn-primary"
                                    label={clubType ? "Continue" : "Continue As Guest"}
                                    onClick={() => {
                                      if (!inProgress)
                                        this.postCreateClubMembershipCart()
                                    }}
                                    style={{ marginRight: '1rem' }}
                                  />
                                  {inProgress && <Loading small />}
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {
                    validateLoginResult &&
                    error &&
                    <div className="container">
                      <div className="row justify-content-center">
                        <div className="col-md-8" style={{ color: '#dc3545' }} >
                          <span>{error.message || ''}</span>
                        </div>
                      </div>
                    </div>
                  }

                  {
                    ClubMember &&
                    clubType &&
                    <div className="container">
                      {switchInProgress &&
                        <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          marginTop: '-8rem'
                        }}>
                          <Loading fullPage />
                          <h2 style={{ marginTop: '-4rem' }}>
                            {`Switching membership to ${toJoinClubName}`}
                          </h2>
                        </div>
                      }
                      {
                        switchError &&
                        <div className="container">
                          <div className="row justify-content-center">
                            <div className="col-md-8" style={{ color: '#dc3545' }} >
                              <span>{switchError.message || ''}</span>
                            </div>
                          </div>
                        </div>
                      }
                      {
                        !switchError &&
                        !switchInProgress &&
                        <>
                          <div className="row justify-content-center">
                            <div className="col-md-8">
                            {clubJoinMessage({clubTypeId, ClubTypeId, ClubName, toJoinClubName, IsDisabled})}
                            </div>
                          </div>

                          {
                            clubTypeId !== ClubTypeId ? (
                              <div className="row justify-content-center">
                                <div className="col-md-8" style={{ marginTop: '1rem' }}>
                                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    { !IsDisabled &&
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        style={{ marginRight: '0.5rem' }}
                                        onClick={
                                          () => {
                                            switchClubMembership({ clubTypeId }, null, null, (result) => {
                                              if (result) this.setState({ redirectToClubInformation: true });
                                            })
                                          }
                                        }
                                      >
                                        Continue
                                      </button>
                                    }

                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary"
                                      style={{ marginRight: '0.5rem' }}
                                      onClick={() => {
                                        this.setState({ redirectToShop: true })
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ) :
                              (
                                <div className="row justify-content-center">
                                  <div className="col-md-8" style={{ marginTop: '1rem' }}>
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      style={{ marginRight: '0.5rem' }}
                                      onClick={
                                        () => {
                                          this.setState({ redirectToShop: true })
                                        }
                                      }
                                    >
                                      Continue to Shop
                                    </button>
                                  </div>
                                </div>
                              )
                          }
                        </>
                      }


                    </div>
                  }


                </main>
              </>
            }
          </div>
          <div className="container text-right">
            <a href="#top" className="back-to-top" onClick={scrollToTop}>
              Back to top
            </a>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapState = state => {
  const { error: loginError } = state.postLogin.toJS();
  const {
    inProgress: validateLoginInProgress,
    result: validateLoginResult
  } = state.validateLogin.toJS();
  const {
    result,
    error,
    inProgress
  } = state.createClubMembershipCart.toJS();

  const {
    error: switchError,
    inProgress: switchInProgress
  } = state.switchClubMembership.toJS();

  const {
    result: clubTypeResult
  } = state.getClubById.toJS();
  return {
    loginError,
    result,
    error,
    inProgress,
    validateLoginInProgress,
    validateLoginResult,
    clubTypeResult,
    switchError,
    switchInProgress
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      postLogin: fetchDux.postLogin.createAction,
      getCart: fetchDux.getCart.createAction,
      validateLogin: fetchDux.validateLogin.createAction,
      createClubMembershipCart: fetchDux.createClubMembershipCart.createAction,
      getClubById: fetchDux.getClubById.createAction,
      switchClubMembership: fetchDux.switchClubMembership.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(ShopLoginRoute);
